import { FormControl, Stack, TextField } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ItemPropertiesDelimiterInput from "../../ItemPropertiesDelimiterInput";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep, debounce } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../../redux/slices/treeSlice";

const EDIRecordProperty = () => {
  const { t } = useTranslation();
  const [delimiter, setDelimeter] = useState("");
  const [position, setPosition] = useState("");
  const [segmentId, setSegmentId] = useState("");
  const [loopId, setLoopId] = useState("");
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const { translatedData } = rightTree.tree[rightTree.currentTab];
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const dispatch = useDispatch();

  const updateHandler = (key, value) => {
    const data = cloneDeep(translatedData);
    eachDeep(data, (obj) => {
      if (obj?.key === selectedNode?.key) {
        obj[key] = value;
        return;
      }
    });
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: data,
      })
    );
  };

  const debounceChangeHandler = useCallback(debounce(updateHandler, 800), [
    rightTree.currentTab,
    rightTree.tree,
  ]);

  useEffect(() => {
    setDelimeter(selectedNode?.DELIMITER || "");
    setPosition(selectedNode?.POSITION_NUMBER || "");
    setSegmentId(selectedNode?.SEGMENT_ID || "");
    setLoopId(selectedNode?.LOOP_ID || "");
  }, [selectedNode?.key]);

  return (
    <>
      <Stack spacing={"10px"} className="tp-segment">
        <ItemPropertiesDelimiterInput
          label={t("LBL_FLD_DELIM_OVERRIDE_OPTIONAL")}
          name={"DELIMITER"}
        />
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("POSITION_NUMBER")}
            type="text"
            className={"width-100"}
            value={position}
            onChange={(e) => {
              const { value } = e.target;
              debounceChangeHandler("POSITION_NUMBER", value);
              setPosition(value);
            }}
          />
        </FormControl>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("MAP_SEGMENT_ID")}
            type="text"
            className={"width-100"}
            value={segmentId}
            onChange={(e) => {
              const { value } = e.target;
              debounceChangeHandler("SEGMENT_ID", value);
              setSegmentId(value);
            }}
          />
        </FormControl>
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("MAP_LOOP_ID")}
            type="text"
            className={"width-100"}
            value={loopId}
            onChange={(e) => {
              const { value } = e.target;
              debounceChangeHandler("LOOP_ID", value);
              setLoopId(value);
            }}
          />
        </FormControl>
      </Stack>
    </>
  );
};

export default EDIRecordProperty;
